import { jwtDecode } from 'jwt-decode';

const TOKEN_KEY = "token";
const REFRESH_TOKEN_KEY = "refreshToken";
const IS_LOGIN_SSO_KEY = "isLoginSSO"
const TYPE_VIEW = 'typeView'

const StorageConfig = {
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  getRefreshToken() {
    return localStorage.getItem(REFRESH_TOKEN_KEY);
  },

  getPermissions(){
    let userData = StorageConfig.getUserData()
    return userData.permissions;
  },

  getGroups(){
    let userData = StorageConfig.getUserData()
    return userData.groups;
  },

  saveToken(accessToken) {
    return localStorage.setItem(TOKEN_KEY, accessToken);
  },

  saveRefreshToken(refreshToken){
    return localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  },

  saveIdTokenSSO(idToken){
    return localStorage.setItem("idToken",idToken)
  },

  getIdTokenSSO(){
    return localStorage.getItem("idToken")
  },

  saveIsLoginSSO(isLoginSSO = 'false'){
    return localStorage.setItem(IS_LOGIN_SSO_KEY,isLoginSSO)
  },

  getIsLoginSSO(){
    return localStorage.getItem(IS_LOGIN_SSO_KEY)
  },

  saveTypeView(type){
    return localStorage.setItem(TYPE_VIEW,type)
  },

  getTypeView(){
    return localStorage.getItem(TYPE_VIEW)
  },

  getUserData(){
    const token = localStorage.getItem(TOKEN_KEY); // or wherever you store it
    let decoded = null;
    if (token) {
      decoded = jwtDecode(token);
    }
    decoded["role"] = decoded?.groups[0]?.name ?? '-'
    return decoded
  },

  saveSessionLogin({token, refreshToken, isLoginSSO = 'false'}){
    StorageConfig.saveToken(token);
    StorageConfig.saveRefreshToken(refreshToken);
    StorageConfig.saveIsLoginSSO(isLoginSSO)
  },

  clearSession() {
    if(StorageConfig.getIsLoginSSO() === 'true'){
      localStorage.removeItem("idToken")
    }
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_TOKEN_KEY);
    localStorage.removeItem(IS_LOGIN_SSO_KEY);
    localStorage.clear();
  },
};

export default StorageConfig;
